import { BaseModel } from "sjs-base-model";

export default class UserInfoModel extends BaseModel {
    public readonly cdc: string = "";
    public readonly tipoCdc: string = "";
    public readonly tipoFigProvv: string = "";
    public readonly codFiliale: string = "";
    public readonly idAgente: number = 0;
    public readonly descrizioneUO: string = "";
    public readonly codiceAgenzia: string = "";

    constructor(data: Partial<UserInfoModel>) {
        super();

        this.update(data);
    }
}
